import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import FilterSelector from '@client/modules/ListModules/FilterSelector';
import gsap from 'gsap';
import FilterStore from '@client/modules/ListModules/FilterStore';
import FilteredListViewSelector from './FilteredListViewSelector';
import FilteredListFilterToggle from './FilteredListFilterToggle';

const ListNav = styled.div`
	width: 100%;
	padding: 0px var(--gridMargin);
	padding-top: 100px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
`;

const FilterSelectorContainer = styled.div`
	position: relative;
	width: 100%;
	overflow: hidden;
	z-index: 1;
`;

const FilterSelectorPlacer = styled.div`
	position: absolute;
	height: fit-content;
	width: 100%;
`;

export default function FilteredListToolbar({
	allowListView,
	useDateFilter,
	useTagFilter,
	useLocationFilter,
	backgroundColorLink,
}: {
	allowListView?: boolean;
	useDateFilter: boolean;
	useTagFilter: boolean;
	useLocationFilter: boolean;
	backgroundColorLink: any;
}) {
	const filterSelectorContainerRef = useRef<HTMLDivElement | null>(null);
	const [filtersOpen, setFiltersOpen] = useState(false);

	const dateFilterPossibilities = FilterStore.use(state => state.dateFilters);
	const tagFilterPossibilities = FilterStore.use(state => state.tagFilters);
	const locationFilterPossibilities = FilterStore.use(state => state.locationFilters);

	useEffect(() => {
		openFilters();
	}, [dateFilterPossibilities, tagFilterPossibilities, locationFilterPossibilities]);

	useEffect(() => {
		if (!allowListView && FilterStore.get().view === 'list') {
			FilterStore.setView('tile');
		}
	}, [allowListView]);

	const toggleOpenFilter = () => {
		if (filtersOpen) {
			closeFilters();
		} else {
			openFilters();
		}
	};

	const closeFilters = () => {
		if (!filterSelectorContainerRef.current) return;

		setFiltersOpen(false);
		gsap.to(filterSelectorContainerRef.current, {
			height: 0,
			duration: 0.3,
		});
	};

	const openFilters = () => {
		if (!filterSelectorContainerRef.current) return;

		setFiltersOpen(true);
		gsap.to(filterSelectorContainerRef.current, {
			height: filterSelectorContainerRef.current.firstElementChild?.getBoundingClientRect().height + 'px',
			duration: 0.3,
		});
	};

	return (
		<>
			<ListNav>
				{(useDateFilter || useTagFilter || useLocationFilter) && (
					<FilteredListFilterToggle onClick={toggleOpenFilter} isOpen={filtersOpen} />
				)}
				{allowListView && <FilteredListViewSelector />}
			</ListNav>
			{(useDateFilter || useTagFilter || useLocationFilter) && (
				<FilterSelectorContainer ref={filterSelectorContainerRef}>
					<FilterSelectorPlacer>
						<FilterSelector
							data={{
								onButtonClick: closeFilters,
								useDateFilter: useDateFilter,
								useTagFilter: useTagFilter,
								useLocationFilter: useLocationFilter,
								backgroundColor: backgroundColorLink,
							}}
						/>
					</FilterSelectorPlacer>
				</FilterSelectorContainer>
			)}
		</>
	);
}
